import { CountUp } from "countup.js";
import lozad from "lozad";
export function lazyLoad() {
	const observer = lozad(".lozad");
	observer.observe();
}
export function setBackgroundElement() {
	$("[setBackground]").each(function () {
		var background = $(this).attr("setBackground");
		$(this).css({
			"background-image": "url(" + background + ")",
			"background-size": "cover",
			"background-position": "center center",
		});
	});
}
export function detectCloseElement(ele, ele2, funcRemove) {
	// close
	$(document).on("click", function (e) {
		console.log();
		if (!$(e.target).closest(ele).length && !$(e.target).hasClass(ele2)) {
			funcRemove();
		}
	});
	// esc
	$(document).keyup(function (e) {
		if (e.key === "Escape") {
			funcRemove();
		}
	});
	// overlay-blur
}
export function buttonToTop() {
	$(document).on("scroll", function () {
		if ($(this).scrollTop()) {
			$("#backtop").fadeIn();
		} else {
			$("#backtop").fadeOut();
		}
	});
	$("#backtop").click(function () {
		$("html, body").animate({
			scrollTop: 0
		}, 1000);
	});
}


export function ToggleItem() {
	const nodeParent = $(".wrap-item-toggle");
	const nodeItem = nodeParent.find(".item-toggle");
	const nodeTitle = nodeItem.find(".title");
	nodeTitle.on("click", function () {
		$(this).toggleClass("active").next().slideToggle().closest(".item-toggle").siblings().find(".title").removeClass("active").next().slideUp();
	});
}

/**
 * parent, children, item, button, initItem
 * @param { parent, children, item, button, initItem} listNode
 */
export function funcExpandContent(listNode) {
	const { parent, children, item, button, initItem, gap = 0 } = listNode;
	if (!$(parent).length) return;
	let itemHeight = $(item).outerHeight();
	let gapCalculate = gap ? Number($(parent).find(children).css("column-gap").slice(0, -2)) * gap : 0;
	let initHeight = itemHeight * initItem + gapCalculate;
	let originalHeight = $(parent).find(children).outerHeight();
	if (originalHeight < initHeight) {
		$(button).remove();
	} else {
		$(parent).css("height", initHeight);
	}
	$(button).on("click", function () {
		if ($(this).hasClass("expand")) {
			$(parent).css("height", initHeight);
			$(this).find("span").text("Xem thêm");
		} else {
			$(parent).css("height", originalHeight);
			// setTimeout(() => {
			// 	$(parent).css("height", "auto");
			// }, 1000);
			$(this).find("span").text("Rút gọn");
		}
		$(this).toggleClass("expand");
	});
}

export function clickScrollToDiv(nodeEle, heightSpacing = () => { }) {
	$(nodeEle).on("click", function (event) {
		let height = 0;
		$(this).addClass("active").siblings().removeClass("active");
		if (heightSpacing) {
			height = heightSpacing();
		} else {
			height = 0;
		}
		if (this.hash !== "") {
			event.preventDefault();
			var hash = this.hash;
			$("html, body").animate(
				{
					scrollTop: $(hash).offset().top - height,
				},
				800
			);
		}
	});
}

export function initTeanisAnimation() {
	if ($(".teanis-path").length === 0) return;

	gsap.registerPlugin(ScrollTrigger);

	gsap.from(".teanis-path", {
		scrollTrigger: {
			trigger: ".teanis-path", // 1. Lấy mốc là chính nó
			// start: "top bottom",  // (Mặc định) Khi đỉnh element chạm đáy màn hình
			start: "top 20%",        // 2. Chỉnh lại: Khi đỉnh của path chạm vào khoảng 60% chiều cao màn hình thì chạy
			toggleActions: "play none none reverse",
			// markers: true,        // Bật lên để canh chỉnh vị trí
		},
		y: -500,      // 3. QUAN TRỌNG: Số ÂM để nó nằm ở trên cao
		opacity: 0,
		duration: 1,
		ease: "power3.out"
	});
}

export function replaceSvgImages() {
	$(".img-svg").each(function () {
		const $img = $(this);
		const imgURL = $img.attr("src");
		const imgClass = $img.attr("class");

		$.ajax({
			url: imgURL,
			dataType: "text",
			success: function (svgContent) {
				// Tạo div tạm để chứa SVG
				const $svgDiv = $("<div>").html(svgContent);
				const $svg = $svgDiv.find("svg");
				if (imgClass) {
					$svg.addClass(imgClass);
				}
				$svg.removeAttr('xmlns:a');
				$img.replaceWith($svg);
				if ($svg.find('.teanis-path').length > 0) {
					initTeanisAnimation();
				}
			},
			error: function (error) {
				console.error("Error fetching SVG:", error);
			},
		});
	});
}

export function countUpInit() {
	const countUpElements = document.querySelectorAll(".countup");

	countUpElements.forEach((element) => {
		const targetNumber = element.getAttribute("data-number");
		const suffix = element.getAttribute("data-suffix") || "";
		const countValueEl = element.querySelector(".count-value");

		if (!countValueEl) return;

		const countUp = new CountUp(countValueEl, targetNumber, {
			duration: 4,
			separator: ".",
			decimal: ",",
			suffix: suffix,
			enableScrollSpy: true,
		});

		if (!countUp.error) {
			countUp.start();
		} else {
			console.error(countUp.error);
		}
	});
}